import React, { useState } from "react";
import { Button, Form, Row, Col, Select, Input, message } from "antd/lib";
import axiosInPosp from "../../Redux/axios/AxiosInPosp";
import { useSelector, useDispatch } from "react-redux";
import { SingleQuote, GetQuotes } from "../../Redux/actions/NumBikeation";
import { DownloadOutlined } from "@ant-design/icons";
export default function Remarks() {
  const ViewSingleQuote = useSelector((state) => state?.posp?.PospViewQuote);
  console.log(ViewSingleQuote);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const onFinishFailed = (values) => {
    console.log(values);
  };
  const onFinish = (values) => {
    console.log(values);
    setLoading(true);
    let post = {
      status: values?.status,
      _method: "PUT",
    };
    const formData = new FormData();
    Object.keys(post).forEach((key) => {
      formData.append(key, post[key]);
    });
    axiosInPosp
      .post(`v1/posp/quick_quotes/${ViewSingleQuote.id}`, formData)
      .then((res) => {
        console.log(res);
        message.success("Payment status updated");
        let updateQuote = res?.data?.data;
        console.log(updateQuote);
        dispatch(SingleQuote(updateQuote));
        dispatch(GetQuotes());
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };
  return (
    <>
      <div className="bpodoc-detail">Payment Status Update</div>
      <div className="row">
        <div className="col-xl-12 col-lg-6 px-3 col-md-6">
          <Form
            layout="vertical"
            form={form}
            requiredMark={false}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
          >
            <Row gutter={24} className="align-items-center">
              <Col span={12}>
                <Form.Item
                  name="status"
                  rules={[
                    {
                      required: true,
                      message: "Please select status",
                    },
                  ]}
                  initialValue={
                    ViewSingleQuote?.status === "Payment done"
                      ? ViewSingleQuote?.status
                      : null
                  }
                >
                  <Select
                    placeholder="Payment Status"
                    defaultValue="Select"
                    options={[
                      {
                        label: "Payment Done",
                        value: "Payment done",
                      },
                    ]}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item style={{ textAlign: "center" }}>
                  <Button
                    loading={loading}
                    type="primary"
                    style={{ backgroundColor: "#3097de", border: "#3097de" }}
                    htmlType="submit"
                  >
                    Update
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
        <div className="col-xl-6 col-lg-6 px-3 col-md-6 d-flex justify-content-end">
          {ViewSingleQuote?.policy_pdf ? (
            <Button
              type="primary"
              icon={<DownloadOutlined />}
              className="policy-pdf-dwnld"
              htmlType="submit"
            >
              <a href={ViewSingleQuote?.policy_pdf} target="_blank">
                Policy Pdf
              </a>
            </Button>
          ) : null}
        </div>
      </div>
    </>
  );
}
